module.exports = __webpack_public_path__ + "static/confetti-5a058adde54e2f02d9a418008bd21c88.png";